import { Lightning } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';
import { ScrollList } from '../../components/shared/ScrollList';
import { ScreenSize } from '../../api/ScreenSize';
import { RecordingSection } from './api/RecordingSection';
import { PincodeSection } from './api/PincodeSection';
import { UserSection } from './api/UserSection';
import { StaticPageUrls } from '../../api/analytics/ClientEvents';
import { PlayerSection } from './api/PlayerSection';

/**
 * @property {Backend} backend
 */
export class SettingsPage extends Lightning.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: h => h,
      color: Theme.Colors.Transparent,
      ItemList: {
        y: 0,
        h: ScreenSize.h,
        w: 750,
        x: 160,
        clipping: true,
        type: ScrollList,
        Items: {
          w: 750,
        },
        signals: {
          onActivate: 'itemActivated',
        },
      },
    };
  }

  _init() {
    this.backend = this.params.backend;
    this.backend.logService.trackPageView(StaticPageUrls.settings);
    let sections = [];
    if (this.backend.sessionInfo.npvr && this.backend.sessionInfo.npvr.id) {
      sections = [
        new RecordingSection(this.backend),
        new PlayerSection(this.backend),
        new PincodeSection(this.backend),
        new UserSection(this.backend),
      ];
    } else {
      sections = [
        // new AudioSection(this.backend),
        // new SubtitleSection(this.backend),
        new PlayerSection(this.backend),
        new PincodeSection(this.backend),
        // new AdultModeSection(this.backend),
        // new ReminderSection(this.backend),
        new UserSection(this.backend),
      ];
    }

    const list = this.tag('ItemList');
    sections.forEach(section => {
      section.addControls(list);
    });
    list.focusFirstVisible();
  }

  _handleBack() {
    this.fireAncestors('$focusMenu');
    return true;
  }

  _getFocused() {
    return this.tag('ItemList');
  }

  itemActivated(item) {
    const action = item.data.action;
    if (action && typeof action === 'function') {
      action(item);
    }
  }
}
